<template>
    <section>
        <div class="columns is-variable is-1-desktop mb-0">
            <div class="column is-narrow">
                <b-button
                    expanded
                    @click="toggleVisibility"
                    :outlined="filtersAreOpen ? true : false"
                    :type="filtersAreOpen ? 'is-dark' : 'is-primary'"
                    :icon-right="filtersAreOpen ? 'minus' : 'plus'"
                >
                    Filtros
                </b-button>
            </div>
            <div class="column is-6"  v-show="filtersAreOpen">
                <slot :fields="fields"></slot>
            </div>
            <div class="column is-3" v-show="filtersAreOpen">
                <div class="columns is-variable is-1-desktop">
                    <div class="column is-4">
                        <b-button expanded type="is-primary" @click="search">Buscar</b-button>
                    </div>
                    <div class="column is-8">
                        <b-button expanded outlined type="is-secondary" @click="clean">Limpiar búsqueda</b-button>
                    </div>
                </div>
            </div>
        </div>
        <b-message
            class="is-size-6 filterMessageCustomMessage"
            size="is-small"
            v-show="emptyMessageIsOpen"
            type="is-info"
            has-icon
            icon-size="is-small"	
            icon="info-circle">
            Ingresa al menos un filtro para poder buscar en la tabla
        </b-message>
  </section>
</template>

<script>
const objtHasEmptyValues = (obj) => Object.values(obj).every(val => !val )

export default {
    name: "FiltersGeneric",
    props: {
        fieldsName: {
            type: Array,
            default: ()=>[]
        },
    },
    watch: {
        fields: {
            handler: function(val) {
                if (!objtHasEmptyValues(val)) this.emptyMessageIsOpen = false
            },
            deep: true
        }
    },
    data() {
        return {
            fields: this.fieldsNameToObject(),
            filtersAreOpen: false,
            emptyMessageIsOpen: false,
        }
    },
    methods: {
        fieldsNameToObject: function() {
            return this.fieldsName.reduce((ojb, key) => ({ ...ojb, [key]: null}), {});
        },
        toggleVisibility: function() {
            this.filtersAreOpen = !this.filtersAreOpen;
            this.emptyMessageIsOpen = false;
            this.emptyFields();
            this.$emit('on-toggle-visibility', this.filtersAreOpen);
        },
        search: function() {
            if (objtHasEmptyValues(this.fields)) {
                this.emptyMessageIsOpen = true;
                return false
            }
            this.$emit('on-search', this.fields)
        },
        emptyFields: function() {
            this.fields = Object.keys(this.fields).reduce(
                (attrs, key) => ({
                    ...attrs,
                    [key]: null
                }),
                {}
            )
        },
        clean: function() {
            this.emptyFields();
            this.$emit('on-clean');
        },
    }
};
</script>